module.exports = "<div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label i18n-label=\"Archived Documents\" i18n-help=\"Archived Documents Help\"></app-widgets-label> <app-widgets-archived-document-list ng-model=route.documents poi-id=route.destination_poi_id></app-widgets-archived-document-list> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/general/partial_archive.html
// module id = 468
// module chunks = 0